import { heating_id_2_pump_id, heating_id_2_tap_id, heating_id_2_water_sensor_id, } from '../constants';
export const getObjectLinks = (id, objectsArrays) => {
    return (objectsArrays?.find((array) => array.objects_links.includes(id))
        ?.objects_links ?? []);
};
export const getPumpId = (objectsArrays, pumps, circuitId) => {
    return (pumps?.find((pump) => getObjectLinks(circuitId, objectsArrays).includes(pump.id))?.id ?? heating_id_2_pump_id(circuitId));
};
export const getSensorId = (objectsArrays, sensorIds, circuitId) => {
    return (sensorIds?.find((sensorId) => getObjectLinks(circuitId, objectsArrays).includes(sensorId)) ?? heating_id_2_water_sensor_id(circuitId));
};
export const getTapId = (objectsArrays, taps, circuitId) => {
    return (taps?.find((tap) => getObjectLinks(circuitId, objectsArrays).includes(tap.id))
        ?.id ?? heating_id_2_tap_id(circuitId));
};
